module.exports = __webpack_public_path__ + "7114ca7e1f8978481275edfcf0afbe08.svg";